import { render, staticRenderFns } from "./GroupAppointmentList.vue?vue&type=template&id=03d71d86&"
import script from "./GroupAppointmentList.vue?vue&type=script&lang=js&"
export * from "./GroupAppointmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports